import { connect, ConnectedProps } from "react-redux";
import { RootState } from "../store/store"; // Assuming your store file is named 'store.ts'
import { Button, Col, Form, Input, InputNumber, Row, Select } from "antd";
import { SendOutlined } from "@ant-design/icons";
import { deleteData, fetchData, postData, putData } from "../store/actions/cms";
import { useState } from "react";
import { PATH_EXPENSE as PATH, PATH_MANAGE, PATH_STORE } from "../config";

import { isArray } from "lodash";

import { useQuery } from "@tanstack/react-query";
import { queryApi } from "../store/actions/common";
import socketService from "../config/ws-config";
import { triggerNotification } from "../store/directActions";

interface OwnProps {}

type configurationPageProps = OwnProps & PropsFromRedux;

const PAGE_TYPE = "expense";

const ConfigurationPage: React.FC<configurationPageProps> = ({ storeId }) => {
  const [form] = Form.useForm();

  const {
    data: storeData,
    isPending,
    isError,
    error,
  } = useQuery({
    queryKey: [PATH_STORE, { type: "all" }],
    // queryFn: ({ signal, queryKey }) => fetchEvents({ signal, ...queryKey[1] }),
    queryFn: () => queryApi(PATH_STORE, "GET"),
    staleTime: Infinity,
    gcTime: 0,
  });

  const onFormSubmit = (values: Record<string, any>) => {
    const notification = {
      type: values.type ?? "success",
      subject: values.subject ?? "",
      description: values?.description,
      duration: values?.duration ?? 60,
    };

    if (!values.store || values?.store?.length === 0) {
      socketService.sendGeneralMessage("notify", notification);
    } else if (isArray(values.store)) {
      values?.store?.forEach((i: any) => {
        socketService.sendMessage("notify", notification, i);
      });
    } else {
      triggerNotification({
        title: "Something went wrong, notification not sent",
        type: "error",
        description: "",
      });
      return;
    }

    triggerNotification({
      title: "Notification sent successfully",
      type: "success",
      description: "",
    });
    form.resetFields();
  };

  return (
    <section id="customers" className="page-section h-page p-6 flex flex-col">
      <div className="mb-4">
        <h2 className="text-2xl font-bold app-text">
          Notifications
        </h2>
        <p className="app-muted mt-2">
          Send notifications to all stores or specific groups of stores.
        </p>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-1 gap-6">
        <div className="lg:col-span-1">
          <div className="app-surface rounded-xl shadow-sm border border-solid app-border p-6">
            <h3 className="text-lg font-semibold app-text mb-4">
              Send Notification
            </h3>

            <Form form={form} layout="vertical" onFinish={onFormSubmit}>
              <Row gutter={[16]}>
                <Col span={12}>
                  <Form.Item
                    name="type"
                    label="Type"
                    // rules={[{ required: true, message: "Please enter user name" }]}
                  >
                    {/* <Input placeholder="Please enter user name" /> */}
                    <Select
                      allowClear
                      placeholder="type"
                      options={[
                        { label: "Success", value: "success" },
                        { label: "Info", value: "info" },
                        { value: "warning", label: "Warning" },
                        { value: "error", label: "Error" },
                      ]}
                    />
                  </Form.Item>
                </Col>
                <Col span={12}>
                  <Form.Item
                    name="duration"
                    label="Duration (in seconds)"
                    extra="This is default to 60 seconds"
                    // rules={[{ required: true, message: "Please enter user name" }]}
                  >
                    <InputNumber
                      style={{ width: "100%" }}
                      placeholder="in seconds"
                    />
                  </Form.Item>
                </Col>
                <Col span={24}>
                  <Form.Item
                    name="store"
                    label="Store"
                    extra="If no store is selected then all stores receive notification"
                    // rules={[{ required: true, message: "Please enter user name" }]}
                  >
                    {/* <Input placeholder="Please enter user name" /> */}
                    <Select
                      // showSearch
                      allowClear
                      mode="multiple"
                      placeholder="store"
                      optionFilterProp="label"
                      filterOption={(input, option) =>
                        (option?.label ?? "")
                          .toLowerCase()
                          .includes(input.toLowerCase())
                      }
                      options={
                        !!storeData && isArray(storeData)
                          ? storeData.map((i) => ({
                              value: i?.user_id,
                              label: `${
                                i?.store_data?.[0]?.name ?? i?.user_id
                              } (${i?.email})`,
                            }))
                          : []
                      }
                    />
                  </Form.Item>
                </Col>
                <Col span={24}>
                  <Form.Item
                    name="subject"
                    label="Subject"
                    rules={[
                      { required: true, message: "Please enter subject" },
                    ]}
                  >
                    <Input
                      placeholder="Please enter subject"
                      showCount
                      maxLength={80}
                    />
                  </Form.Item>
                </Col>
                <Col span={24}>
                  <Form.Item
                    name="description"
                    label="Body"
                    // rules={[{ required: true, message: "Please enter body" }]}
                  >
                    <Input.TextArea
                      placeholder="Please enter user name"
                      showCount
                      maxLength={200}
                    />
                  </Form.Item>
                </Col>
                <Col span={24}>
                  <Button
                    icon={<SendOutlined />}
                    type="primary"
                    style={{ width: "100%" }}
                    onClick={form.submit}
                  >
                    Send
                  </Button>
                </Col>
              </Row>
            </Form>
          </div>
        </div>

        {/* Past Notifications */}
        {/* <div className="lg:col-span-2">
          <div className="app-surface rounded-xl shadow-sm border border-solid app-border p-6">
            <h3 className="text-lg font-semibold app-text mb-4">
              Notification History
            </h3>

            <div className="space-y-4">
              {pastNotifications.map((notif) => (
                <div
                  key={notif.id}
                  className="border app-border rounded-lg p-4 app-hover transition-colors duration-150"
                >
                  <div className="flex items-start justify-between mb-2">
                    <div className="flex-1">
                      <h4 className="text-sm font-medium app-text">
                        {notif.title}
                      </h4>
                      <p className="text-sm app-muted mt-1">
                        {notif.message}
                      </p>
                    </div>
                    <div className="flex items-center space-x-2 ml-4">
                      {getStatusIcon(notif.status)}
                      <span
                        className={`inline-flex px-2 py-1 text-xs font-medium rounded-full ${getStatusColor(
                          notif.status
                        )}`}
                      >
                        {notif.status}
                      </span>
                    </div>
                  </div>

                  <div className="flex items-center justify-between text-xs app-muted">
                    <div className="flex items-center space-x-4">
                      <span>
                        {notif.date} at {notif.time}
                      </span>
                      <span>{notif.recipients} recipients</span>
                    </div>
                    <button className="flex items-center space-x-1"
                    style={{ color: "var(--dash-link)" }}
                  >
                      <Eye className="h-3 w-3" />
                      <span>View</span>
                    </button>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div> */}
      </div>
    </section>
  );
};

const mapStateToProps = (state: RootState) => ({
  // Map state properties to props here if needed
  data: state.cms?.[PAGE_TYPE],
  storeId: state.user?.profileData?.storeId,
  REFRESH: state.levent?.[PAGE_TYPE],
});

const mapDispatchToProps = (dispatch: any) => ({
  // login: (data: any) => dispatch(getProfile(data)),
  fetchCms: (reqData: any) =>
    dispatch(fetchData(PATH_MANAGE, PATH, reqData, PAGE_TYPE)),
  generateToken: (id: any) =>
    dispatch(fetchData(PATH_MANAGE, `${PATH}/login/app/${id}`, {}, "")),
  createData: (reqData: any) =>
    dispatch(postData(PATH_MANAGE, `${PATH}`, reqData, PAGE_TYPE)),

  editData: (id: string, reqData: any) =>
    dispatch(putData(PATH_MANAGE, `${PATH}/`, id, reqData, PAGE_TYPE)),
  removeCms: (reqData: any) =>
    dispatch(deleteData(PATH_MANAGE, `${PATH}/`, reqData, PAGE_TYPE)),
});

const connector = connect(mapStateToProps, mapDispatchToProps);

// Define the props that connect will inject into the component
type PropsFromRedux = ConnectedProps<typeof connector>;

// Connect the component to Redux
export default connector(ConfigurationPage);
